import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip from 'libraries/Tooltip';
import CompanyLogo from 'components/logos/company_logo';
import RetinaImage from 'react-retina-image';
import CloseIcon from './closeIcon';
import { convertMinutes } from '../../../common/commonFunc';

import styles from './styles';

const PreviewHeader = ({
    handleClosePreview, classes,
    interview, company, brand, loading
}) => {
    const logo = brand?.logoUrl[0]
        ? (
            <RetinaImage
                alt="logo"
                src={brand?.logoUrl}
                className={classes.logo}
            />
        ) : (
            <CompanyLogo
                sizeHeight={40}
                company={company}
                className={classes.companyLogo}
            />
        );

    const renderedButton = (
        <Tooltip
            label="Exit candidate preview"
            placement="left"
        >
            <IconButton onClick={handleClosePreview} size="large">
                <CloseIcon className={classes.closeIcon} />
            </IconButton>
        </Tooltip>
    );

    if (!interview) {
        return (
            <div className={classes.headerPanel}>
                <div
                    className={classes.logoWrapper}
                >
                    {!loading && logo}
                </div>
                <div>
                    { renderedButton }
                </div>
            </div>
        );
    }
    const { timerCount, timerEnabled } = interview;
    const timeLabel = timerEnabled ? `${convertMinutes(timerCount)} remaining` : '';

    return (
        <div className={classes.headerPanel}>
            <div
                className={classes.logoWrapper}
            >
                {!loading && logo}
                <span className={classes.timeLimit}>
                    {timeLabel}
                </span>
            </div>
            <div>
                { renderedButton }
            </div>
        </div>
    );
};

export default withRouter(withStyles(styles)(PreviewHeader));
